<ssc-base-overlay (closed)="closed.emit()">
  <dap-lib-button
    (click)="closed.emit()"
    buttonSize="medium"
    class="close"
    variant="close"
    data-cy="button-close-overlay"
    data-analytics="overlay-close"
  ></dap-lib-button>

  <div class="container">
    <div [class]="mode">
      <h1 class="headline-1">{{ title }}</h1>
      <div class="introduction body-1">
        {{ subtitle }}
      </div>
      <div class="content">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
  </div>

  <div
    [ngClass]="{
      'highlight-yellow': highlightFooter === 'yellow',
      'highlight-violet': highlightFooter === 'violet',
    }"
    class="footer"
  >
    <ng-content select="[secondary-action]"></ng-content>
    <ng-content select="[contactBtn]"></ng-content>
    <div class="main-action">
      <ng-content select="[priceInfo]"></ng-content>
      <ng-content select="[primary-action]"></ng-content>
    </div>
  </div>
</ssc-base-overlay>
